/* ============================================================
   Shop couche page: behaviors of the s-shop-couche-* sections.
   Each section includes this file, so it guards against running twice.
   Components are wired through data attributes and re-initialized on
   `shopify:section:load` for the theme editor.
   ============================================================ */
(function () {
  if (window.ShopCouche) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(root, selector, fn) {
    var nodes = root.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].hasAttribute('data-sc-ready')) continue;
      nodes[i].setAttribute('data-sc-ready', '');
      fn(nodes[i]);
    }
  }

  /* --- newcharge prints -------------------------------------
     One shared call to the newcharge API (same endpoint as the mini bab).
     Returns every print, available or not (only the mini bab filters on stock), one entry per printName:
     { id: 'malo', name: 'Malo', image: 'https://cdn.shopify.com/...' }.
     On failure, a "service unavailable" message replaces the page sections,
     between the theme header and footer. */
  var printsRequest = null;

  function fetchPrints() {
    if (printsRequest) return printsRequest;

    var meta = document.querySelector('meta[name="nc_url"]');
    var apiUrl = meta && meta.getAttribute('content');
    if (!apiUrl) {
      printsRequest = Promise.reject(new Error('[shop-couche] Missing nc_url meta'));
    } else {
      printsRequest = fetch(apiUrl.replace(/\/+$/, '') + '/products?subscriptionRole=base&sellable=true', {
        method: 'GET',
        headers: { 'x-app-type': 'storefrontMiniBab', 'Content-Type': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('[shop-couche] newcharge API HTTP ' + res.status);
          return res.json();
        })
        .then(normalizePrints);
    }

    printsRequest.catch(function (err) {
      console.error(err);
      showServiceError();
    });
    return printsRequest;
  }

  function normalizePrints(products) {
    var byId = {};
    var list = [];
    (products || []).forEach(function (product) {
      var id = (product.printName || '').toLowerCase();
      var variants = product.variants || [];
      if (!id || !variants.length) return;

      var first = variants[0];
      var entry = byId[id];
      if (!entry) {
        entry = byId[id] = { id: id, name: first.printNameShort || first.printNameFull || product.printName, image: '' };
        list.push(entry);
      }
      // Diapers visual first, pants only as a fallback
      var isDiapers = (first.productType || []).indexOf('diapers') !== -1;
      if (product.imageUrl && (!entry.image || isDiapers && !entry.hasDiapersImage)) {
        entry.image = product.imageUrl;
        entry.hasDiapersImage = isDiapers;
      }
    });
    return list.filter(function (entry) { return entry.image; });
  }

  // Maximum number of prints shown by a section (data-max), all of them when empty or 0
  function maxPrints(el) {
    var max = parseInt(el.getAttribute('data-max'), 10);
    return max > 0 ? max : Infinity;
  }

  // Shopify CDN images accept a width parameter
  function sizedImage(url, width) {
    if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function fillTemplate(template, name) {
    return (template || '{name}').split('{name}').join(name);
  }

  function showServiceError() {
    var overlay = document.querySelector('[data-sc-service-error]');
    if (!overlay) return;
    overlay.hidden = false;
    document.documentElement.classList.add('sc-service-error-open');
    // The sections above the message are hidden: bring it back into view
    window.scrollTo(0, 0);
  }

  /* --- Hero: print reel ------------------------------------- */
  function initReel(el) {
    var label = el.querySelector('[data-sc-reel-label]');
    var interval = parseInt(el.getAttribute('data-interval'), 10) || 3600;
    var index = 0;

    // Slides are read on each step: newcharge prints are appended after load
    function slides() { return el.querySelectorAll('[data-sc-slide]'); }

    function show(i) {
      var list = slides();
      if (!list.length) return;
      if (list[index]) list[index].classList.remove('is-active');
      index = (i + list.length) % list.length;
      list[index].classList.add('is-active');
      if (label) {
        var text = list[index].getAttribute('data-label') || '';
        label.textContent = text;
        label.hidden = !text;
      }
    }

    if (el.hasAttribute('data-sc-newcharge')) {
      var max = maxPrints(el);
      fetchPrints().then(function (prints) {
        var known = {};
        var list = slides();
        for (var s = 0; s < list.length; s++) {
          var slide = list[s];
          var id = slide.getAttribute('data-print-id');
          if (!id) continue;
          known[id] = slide;
        }
        prints.forEach(function (print) {
          var slide = known[print.id];
          if (slide) {
            // Editor slide without image: use the newcharge visual
            if (slide.hasAttribute('data-sc-print-fill')) fillHeroSlide(el, slide, print);
            return;
          }
          if (slides().length >= max) return;
          slide = document.createElement('div');
          slide.className = 'sc-hero__slide';
          slide.setAttribute('data-sc-slide', '');
          slide.setAttribute('data-print-id', print.id);
          slide.setAttribute('data-label', fillTemplate(el.getAttribute('data-label-template'), print.name));
          fillHeroSlide(el, slide, print);
          el.insertBefore(slide, label);
        });
      }, function () {});
    }

    if (reduceMotion) return;
    setInterval(function () {
      if (document.hidden || slides().length < 2) return;
      show(index + 1);
    }, interval);
  }

  function fillHeroSlide(el, slide, print) {
    var img = document.createElement('img');
    img.className = 'sc-cover';
    img.src = sizedImage(print.image, 800);
    img.srcset = [400, 600, 800, 1200].map(function (w) { return sizedImage(print.image, w) + ' ' + w + 'w'; }).join(', ');
    img.sizes = '(min-width: 1000px) 560px, 100vw';
    img.alt = slide.getAttribute('data-alt') || fillTemplate(el.getAttribute('data-alt-template'), print.name);
    img.loading = 'lazy';
    slide.removeAttribute('data-sc-print-fill');
    slide.innerHTML = '';
    slide.appendChild(img);
  }

  /* --- Prints band: newcharge prints ------------------------ */
  function initPrintsNewcharge(el) {
    var groups = el.querySelectorAll('[data-sc-prints-group]');
    if (!groups.length) return;
    var altTemplate = el.getAttribute('data-alt-template');
    var max = maxPrints(el);

    fetchPrints().then(function (prints) {
      var count = groups[0].querySelectorAll('.sc-prints__item').length;
      prints.forEach(function (print) {
        var existing = groups[0].querySelectorAll('[data-print-id="' + print.id + '"]');
        if (existing.length) {
          // Editor print without image: use the newcharge visual, in both passes
          for (var g = 0; g < groups.length; g++) {
            var item = groups[g].querySelector('[data-print-id="' + print.id + '"][data-sc-print-fill]');
            if (item) fillPrintThumb(item, print, g === 0 ? fillTemplate(altTemplate, item.getAttribute('data-name') || print.name) : '');
          }
          return;
        }
        if (count >= max) return;
        count++;
        for (var i = 0; i < groups.length; i++) {
          groups[i].appendChild(buildPrintItem(print, i === 0 ? fillTemplate(altTemplate, print.name) : ''));
        }
      });
    }, function () {});
  }

  function buildPrintItem(print, alt) {
    var figure = document.createElement('figure');
    figure.className = 'sc-prints__item';
    figure.setAttribute('data-print-id', print.id);
    var thumb = document.createElement('div');
    thumb.className = 'sc-prints__thumb';
    var caption = document.createElement('figcaption');
    caption.className = 'sc-prints__caption';
    caption.textContent = print.name;
    figure.appendChild(thumb);
    figure.appendChild(caption);
    fillPrintThumb(figure, print, alt);
    return figure;
  }

  function fillPrintThumb(item, print, alt) {
    var thumb = item.querySelector('.sc-prints__thumb');
    var img = document.createElement('img');
    img.className = 'sc-cover';
    img.src = sizedImage(print.image, 500);
    img.srcset = [270, 400, 500].map(function (w) { return sizedImage(print.image, w) + ' ' + w + 'w'; }).join(', ');
    img.sizes = '(max-width: 639px) 132px, clamp(150px, 15vw, 250px)';
    img.alt = alt;
    img.loading = 'lazy';
    img.draggable = false;
    item.removeAttribute('data-sc-print-fill');
    thumb.innerHTML = '';
    thumb.appendChild(img);
  }

  /* --- Mobile carousels with dots --------------------------- */
  function carouselIndex(el) {
    var kids = el.children;
    var x = el.scrollLeft + el.clientWidth / 2;
    var best = 0;
    var bestGap = Infinity;
    for (var i = 0; i < kids.length; i++) {
      var mid = kids[i].offsetLeft - el.offsetLeft + kids[i].offsetWidth / 2;
      var gap = Math.abs(mid - x);
      if (gap < bestGap) { bestGap = gap; best = i; }
    }
    return best;
  }

  function initCarousel(el) {
    var dots = el.parentNode.querySelectorAll('[data-sc-dots] .sc-dot');
    if (!dots.length) return;
    var current = -1;
    function update() {
      var i = carouselIndex(el);
      if (i === current) return;
      current = i;
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
    }
    el.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* --- FAQ accordion ---------------------------------------- */
  function initFaq(el) {
    var items = el.querySelectorAll('[data-sc-faq-item]');

    function setOpen(item, open) {
      var button = item.querySelector('[data-sc-faq-toggle]');
      var panel = item.querySelector('[data-sc-faq-panel]');
      var sign = item.querySelector('[data-sc-faq-sign]');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      if (sign) sign.textContent = open ? '−' : '+';
    }

    function openOnly(target) {
      for (var i = 0; i < items.length; i++) setOpen(items[i], items[i] === target);
    }

    for (var i = 0; i < items.length; i++) {
      (function (item) {
        item.querySelector('[data-sc-faq-toggle]').addEventListener('click', function () {
          var isOpen = this.getAttribute('aria-expanded') === 'true';
          if (isOpen) setOpen(item, false);
          else openOnly(item);
        });
      })(items[i]);
    }

    document.addEventListener('shop-couche:faq-open', function (e) {
      var id = e.detail && e.detail.id;
      if (!id) return;
      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-id') === id) { openOnly(items[i]); return; }
      }
    });
  }

  /* --- Horizontally scrolling prints ------------------------ */
  function initPrints(el) {
    var speed = parseFloat(el.getAttribute('data-speed')) || 0.035;
    var pauseUntil = 0;
    var hovered = false;
    var drag = null;
    var pos = 0;
    var lastWrite = -1;
    var visible = true;
    var raf = null;
    var last = performance.now();

    function hold(ms) { pauseUntil = performance.now() + (ms || 2500); }

    function tick(now) {
      var dt = Math.min(64, now - last);
      last = now;
      var auto = !reduceMotion && !drag && !hovered && now > pauseUntil;
      if (!auto) {
        pos = el.scrollLeft;
      } else {
        var half = el.scrollWidth / 2;
        if (Math.abs(el.scrollLeft - pos) > 1) pos = el.scrollLeft;
        pos += dt * speed;
        if (half > 0 && pos >= half) pos -= half;
        el.scrollLeft = pos;
        lastWrite = el.scrollLeft;
      }
      raf = visible ? requestAnimationFrame(tick) : null;
    }

    function start() {
      if (raf) return;
      last = performance.now();
      raf = requestAnimationFrame(tick);
    }

    function endDrag() {
      if (!drag) return;
      drag = null;
      el.style.cursor = '';
      hold(2500);
    }

    el.addEventListener('pointerdown', function (e) {
      hold(2500);
      if (e.pointerType !== 'mouse') return;
      drag = { x: e.clientX, start: el.scrollLeft };
      el.style.cursor = 'grabbing';
    });
    el.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var half = el.scrollWidth / 2;
      var p = drag.start - (e.clientX - drag.x);
      if (half > 0 && p >= half) { p -= half; drag.start -= half; }
      if (half > 0 && p < 0) { p += half; drag.start += half; }
      pos = p;
      el.scrollLeft = p;
    });
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    el.addEventListener('pointerleave', endDrag);
    el.addEventListener('wheel', function () { hold(2500); }, { passive: true });
    el.addEventListener('touchstart', function () { hold(2500); }, { passive: true });
    el.addEventListener('scroll', function () {
      if (Math.abs(el.scrollLeft - lastWrite) > 1) hold(1500);
    }, { passive: true });
    el.addEventListener('mouseenter', function () { hovered = true; });
    el.addEventListener('mouseleave', function () { hovered = false; hold(800); });

    // Only animate while the band is on screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start();
      }).observe(el);
    } else {
      start();
    }
  }

  /* --- UGC videos ------------------------------------------- */
  function initUgc(el) {
    var items = el.querySelectorAll('[data-sc-video]');
    var playing = -1;
    var sound = false;

    function render() {
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var on = playing === i;
        var video = item.querySelector('video');
        var soundButton = item.querySelector('[data-sc-video-sound]');
        video.muted = !(on && sound);
        item.classList.toggle('is-playing', on);
        item.querySelector('[data-sc-video-icon]').textContent = on ? '❚❚' : '▶';
        soundButton.textContent = soundButton.getAttribute(on && sound ? 'data-label-on' : 'data-label-off');
        soundButton.classList.toggle('is-on', on && sound);
      }
    }

    // Videos are not downloaded until the first click: the source is set lazily
    function load(item, video) {
      if (video.getAttribute('src')) return;
      video.addEventListener('playing', function () { item.classList.add('is-started'); }, { once: true });
      video.setAttribute('src', video.getAttribute('data-src'));
      video.preload = 'auto';
    }

    for (var i = 0; i < items.length; i++) {
      (function (i) {
        var item = items[i];
        var video = item.querySelector('video');

        item.querySelector('[data-sc-video-toggle]').addEventListener('click', function () {
          for (var j = 0; j < items.length; j++) {
            if (j !== i) items[j].querySelector('video').pause();
          }
          load(item, video);
          if (video.paused) { video.play(); playing = i; }
          else { video.pause(); playing = -1; }
          render();
        });

        items[i].querySelector('[data-sc-video-sound]').addEventListener('click', function () {
          for (var j = 0; j < items.length; j++) {
            if (j !== i) items[j].querySelector('video').pause();
          }
          load(item, video);
          // Clicking the sound button of another video turns sound on; on the current one it toggles
          sound = playing === i ? !sound : true;
          video.muted = !sound;
          if (video.paused) video.play();
          playing = i;
          render();
        });
      })(i);
    }
    render();
  }

  /* --- Init ------------------------------------------------- */
  function init(root) {
    each(root, '[data-sc-reel]', initReel);
    each(root, '[data-sc-carousel]', initCarousel);
    each(root, '[data-sc-faq]', initFaq);
    each(root, '[data-sc-prints]', initPrints);
    each(root, '[data-sc-prints-newcharge]', initPrintsNewcharge);
    each(root, '[data-sc-ugc]', initUgc);
  }

  // Questions marquee: ask the FAQ to open the targeted item (the link itself scrolls to #faq)
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-sc-faq-open]');
    if (!link) return;
    document.dispatchEvent(new CustomEvent('shop-couche:faq-open', { detail: { id: link.getAttribute('data-sc-faq-open') } }));
  });

  // Hero Trustpilot mini widget: links to #avis, which only exists when the reviews section widget is enabled;
  // otherwise it opens the iconic reviews popin (snippet popin_trustpilot_iconic).
  // popin_trustpilot.js is not reused because it expects the other boxes of the diffusion page.
  function toggleTrustpilotPopin(open) {
    var popin = document.querySelector('[data-scope="trustpilot-popin"] .popin-iconic');
    var overlay = document.querySelector('[data-scope="trustpilot-popin"] .popin-overlay-iconic');
    if (!popin || !overlay) return;
    popin.style.display = open ? 'block' : 'none';
    overlay.style.display = open ? 'block' : 'none';
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-sc-trustpilot-popin-open]')) {
      if (document.getElementById('avis')) return;
      e.preventDefault();
      toggleTrustpilotPopin(true);
      return;
    }
    if (e.target.closest('[data-scope="trustpilot-popin"] .popin-close-iconic')) { toggleTrustpilotPopin(false); return; }
    // A click on the dark overlay, outside the popin, closes it
    if (e.target.closest('[data-scope="trustpilot-popin"] .popin-overlay-iconic') && !e.target.closest('[data-scope="trustpilot-popin"] .popin-iconic')) {
      toggleTrustpilotPopin(false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') toggleTrustpilotPopin(false);
  });

  if (!reduceMotion) document.documentElement.classList.add('sc-smooth');

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    if (window.Trustpilot) {
      var widgets = e.target.querySelectorAll('.trustpilot-widget');
      for (var i = 0; i < widgets.length; i++) window.Trustpilot.loadFromElement(widgets[i]);
    }
  });

  window.ShopCouche = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
